import React, { useState, useId } from 'react';
import { useSelector } from 'react-redux';
import { cn } from '../../../utils/utils';
import useOutsideClick from '../../../utils/useOutsideClick';
import users from '../../users';
import './custom-selector-v2.scss';

export type SelectorOption = {
    label: string | React.ReactNode;
    value: string;
};

type Props = {
    value: string;
    onChange: (value: string) => void;
    options: SelectorOption[];
    placeholder?: string;
    icon?: string;
    className?: string;
    width?: string | number;
    forceDarkMode?: 'light' | 'dark';
};

const CustomSelectorV2 = ({
    value,
    onChange,
    options,
    placeholder = 'Seleccionar...',
    icon,
    className,
    width = '200px',
    forceDarkMode
}: Props) => {
    const darkMode = useSelector(users.selectors.isDarkMode);
    const isDarkMode = forceDarkMode ? forceDarkMode === 'dark' : darkMode;
    
    const [isOpen, setIsOpen] = useState(false);
    const containerId = useId();

    useOutsideClick(containerId, () => {
        if (isOpen) {
            setIsOpen(false);
        }
    });

    const handleSelectOption = (optionValue: string, e: React.MouseEvent) => {
        e.stopPropagation();
        onChange(optionValue);
        setIsOpen(false);
    };

    const selectedOption = options.find(opt => opt.value === value);

    return (
        <div
            id={containerId}
            className={cn(
                'custom-selector-v2',
                { 'custom-selector-v2--dark': isDarkMode },
                { 'custom-selector-v2--open': isOpen },
                className
            )}
            style={{ width }}
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className="custom-selector-v2__control">
                {icon && (
                    <div className="custom-selector-v2__icon">
                        <i className={icon}></i>
                    </div>
                )}
                <div className="custom-selector-v2__value">
                    {selectedOption ? selectedOption.label : placeholder}
                </div>
                <div className="custom-selector-v2__chevron">
                    <i className={cn('fa-solid fa-chevron-down', { 'rotate-up': isOpen })}></i>
                </div>
            </div>

            {isOpen && (
                <div className="custom-selector-v2__dropdown">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className={cn('custom-selector-v2__option', {
                                'custom-selector-v2__option--selected': option.value === value
                            })}
                            onClick={(e) => handleSelectOption(option.value, e)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelectorV2;